import React from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import { FormValues } from '../../../MagicForm/Interfaces/FormValues';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import useApiClient from '../../../Base/Hooks/useApiClient';
import apiClient from '../../../../Services/ApiClient';
import useTranslation from '../../../../Hooks/useTranslation';
// @ts-ignore
import styles from './PatientsGroupsCreateByImport.module.scss';
import useNotification from '../../../../Hooks/useNotification.hook';
import PatientsGroupUpload from '../PatientsGroupsUpload/PatientsGroupUpload';

interface Props {
	onSuccess: () => void;
	groupId: string;
}

const PatientsGroupsAddMembersByImport: React.FC<Props> = ({
	onSuccess,
	groupId,
}) => {
	const { t } = useTranslation();

	const validationScheme = yup.object({
		file: yup
			.mixed()
			.required(t('base.shared.fileIsNotPicked'))
			.test(
				'file-exists',
				t('base.shared.fileIsNotPicked') ?? '',
				value => value instanceof File,
			),
	});

	const formMethods = useForm({
		resolver: yupResolver(validationScheme),
		defaultValues: {},
	});
	const { displayError } = useApiClient();
	const { showNotificationSuccess } = useNotification();

	const handleSubmit = async (values: FormValues) => {
		try {
			const uploadedFiled = await apiClient.postMultipart(
				`/group/${groupId}/member/import`,
				{
					file: values?.file,
				},
			);
			if (uploadedFiled.status === 200) {
				showNotificationSuccess({
					content: t('component.groupMsgs.patientsImported'),
				});
				onSuccess();
			}
		} catch (e) {
			displayError(e);
		}
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<PatientsGroupUpload />
			<SubmitButton onSubmit={handleSubmit} title='base.shared.add' />
		</FormWrapper>
	);
};

export default PatientsGroupsAddMembersByImport;
